import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { LogoSlider } from '../components/LogoSlider';
import { HowItWorks } from '../components/HowItWorks';
import { PricingSection } from '../components/PricingSection';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <>
      <Navbar data-id="element-595" />
      <Hero data-id="element-596" />
      <LogoSlider data-id="element-597" />
      <HowItWorks data-id="element-598" />
      <PricingSection data-id="element-599" />
      <Contact data-id="element-600" />
      <Footer data-id="element-601" />
    </>;
}